var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-vh-100 d-flex align-items-center justify-content-center"},[_c('p',{staticClass:"mb-0"},[_vm._v("正在进入管理后台…")])])
}]

export { render, staticRenderFns }